<template>
  <div class="device-setting-audio-test-component">
    <div class="device-setting-audio-test">
      <div class="device-set-test" data-record-state="ready">
        <div class="device-set-test-header">
          <div class="device-set-test-title-wrapper">
            <p class="device-set-test-title">{{ $t("deviceSetting.preview.micNspeaker.test") }}</p>
          </div>
          <div class="device-set-test-confirm-btn-wrapper">
            <button class="device-set-test-confirm-btn" 
                    @click="$emit('onToggleAudioTest')">{{ $t("common.complete") }}</button>
          </div>
        </div>
        <div class="device-set-test-body">
          <div class="device-set-test-record">
            <div class="device-set-test-record-header">
              <div class="device-set-test-record-complete-container" 
                   v-if="recordState === 'play' || recordState === 'pause'">
                <div class="device-set-test-record-complete-mark"></div>
                <div class="device-set-test-record-complete-text-wrapper">
                  <p class="device-set-test-record-text complete">{{ $t("deviceSetting.audioTest.recode.complete") }}</p>
                </div>
              </div>
              <div class="device-set-test-record-text-container">
                <p class="device-set-test-record-text title">{{ recordTitle }}</p>
                <p class="device-set-test-record-text description" 
                   v-if="recordState === 'ready' || recordState === 'recording' || recordState === 'end'">{{ $t("deviceSetting.audioTest.recode.maxTime") }}</p>
              </div>
            </div>
            <div class="device-set-test-record-body">
              <div class="device-set-test-record-voice"></div>
              <p class="device-set-test-record-text time" 
                 v-if="recordState === 'ready' || recordState === 'recording'  || recordState === 'end'">
                {{this.recordDurationTime}}</p>
              <div class="device-set-test-record-bar-container" 
                   v-show="recordState === 'play' || recordState === 'pause' ">
                <div class="device-set-test-record-bar-wrapper">
                  <input type="range" min="0" value="0" step="0.001" class="device-set-test-record-bar" 
                         :style="recordBarStyle" 
                         ref="recordBar"
                         @input="onSlideRecordBar"/>                  
                </div>
                <div class="device-set-test-record-info-container">
                  <p class="device-set-test-record-info-time">{{ recordCurrentTime }}</p>
                  <p class="device-set-test-record-info-time">{{ recordDurationTime }}</p>
                </div>
              </div>
              <audio style="display: none" controls
                     ref="recordAudio"
                     :src="blobUrl"
                     @durationchange="onDurationChange"
                     @timeupdate="onTimeUpdate"
                     @ended="onEnded"/>
            </div>
            <div class="device-set-test-record-footer">
              <div class="device-set-test-record-btn-container">
                <button class="device-set-test-record-btn record"
                        v-if="recordState === 'ready'"
                        @click="onRecord('recording')">{{ $t("deviceSetting.audioTest.recode.start") }}</button>
                <button class="device-set-test-record-btn end" 
                        v-if="recordState === 'recording'" 
                        @click="onRecord('end')">{{ $t("deviceSetting.audioTest.recode.stop") }}</button>
                <button class="device-set-test-record-btn end" style="pointer-events: none;"
                        v-if="recordState === 'end'">{{ $t("deviceSetting.audioTest.recode.fileCreate") }}</button>
                <button class="device-set-test-record-btn play" 
                        v-if="recordState === 'pause'" 
                        @click="onRecord('play')">{{ $t("deviceSetting.audioTest.play") }}</button>
                <button class="device-set-test-record-btn pause" 
                        v-if="recordState === 'play'" 
                        @click="onRecord('pause')">{{ $t("deviceSetting.audioTest.pause") }}</button>
                <button class="device-set-test-record-btn re-record" 
                        v-if="recordState === 'play' || recordState === 'pause'" 
                        @click="onRecord('ready')">{{ $t("deviceSetting.audioTest.recode.again") }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="device-set-test-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import {grmNoiseCancel} from "@/lib/gooroomee/noisecancel/GrmNoiseCancel-1.0";
let grmNoiseCancel = {};

export default {
  name: 'ModalDeviceSetting',
  components: {
  },
  props: {
    audio: Object,
    audiooutput: Object,
  },
  data() {
    return {
      recordState: 'ready',
      recordPercent: 0,
      mediaRecorder: null,
      recordTimeInterval: null,
      recordStartDate: null,
      recordCurrentTime: '00:00',
      recordDurationTime: '00:00',
      chunks: [],
      blobUrl: null,
      myVoiceAudio: null,
    }
  },
  mounted() {
    this.initMounted();
  },
  beforeDestroy(){
    this.onRecord('pause')
  },
  computed: {
    recordTitle() {
      switch (this.recordState) {
        case 'ready':
          return this.$t('deviceSetting.preview.micNspeaker.startRecord')
        case 'recording':
          return this.$t('deviceSetting.preview.micNspeaker.stopRecord')
        case 'end':
        case 'play':
        case 'pause':
          return this.$t('deviceSetting.preview.micNspeaker.checkSound')
        default :
          return ''
      }
    },
    recordBarStyle() {
      return {
        background: `linear-gradient(to right, #59f 0%, #59f ${this.recordPercent}%, #f1f1f1 ${this.recordPercent}%, #f1f1f1 100%)`,
      }
    }
  },
  methods: {
    async initMounted() {
      this.myVoiceAudio = this.$refs.recordAudio;
      await this.myVoiceAudio?.setSinkId?.(this.audiooutput.deviceId);

      let stream = this.audio.stream;
      if(this.audio.useNoiseCancel && grmNoiseCancel.isAvailable()){
        await grmNoiseCancel.init();
        stream = grmNoiseCancel.setStream({
          stream,
          stopCurrentTrack: true,
          activate: true,
        });
      }

      this.mediaRecorder = new MediaRecorder(stream)
      this.mediaRecorder.onstop = async e => {
        this.recordState = 'end';

        const blob = new Blob(this.chunks, { 'type' : 'audio/ogg; codecs=opus' });
        this.blobUrl = window.URL.createObjectURL(blob);
        this.chunks = [];
      }
      this.mediaRecorder.ondataavailable = e => {
        this.chunks.push(e.data);
      }
    },
    onDurationChange(e){
      let myVoiceAudio = this.myVoiceAudio;
      
      if (e.target.duration === Number.POSITIVE_INFINITY) {
        myVoiceAudio.muted = true;
        myVoiceAudio.play();
        return;
      }

      myVoiceAudio.muted = false;
      myVoiceAudio.currentTime = 0;
      this.onRecord('play');

      this.$refs.recordBar.max = e.target.duration;

      let duration = String(e.target.duration).substr(0, 4).replace('.', '.');
      if (duration.length === 1) { duration = `${duration}:00` }
      else if (duration.length === 3) { duration = `${duration}0` }
      this.recordCurrentTime = `0${duration}`;
    },
    onTimeUpdate(e){
      this.slideRecordBar(e);
      this.$refs.recordBar.value = this.myVoiceAudio.currentTime
    },
    onEnded(e){
      this.recordState = 'pause';
      this.slideRecordBar(e, true);
      this.$refs.recordBar.value = this.$refs.recordBar.max;
    },
    onSlideRecordBar(e) {
      this.myVoiceAudio.pause();

      this.slideRecordBar(e);
      this.myVoiceAudio.currentTime = e.target.value;
      this.playMyRecord();
    },
    slideRecordBar(e, ended) {
      const val = e.target.value || e.target.currentTime;
      if (!val) {
        return;
      }
      const recordBar = this.$refs.recordBar;
      const percent = ended ? 100 : val / recordBar.max * 100;
      this.recordPercent = percent;
      
      let currentTime = String(val).replace('.', ':').substr(0, 4);
      if (recordBar.value > Number(this.recordDurationTime.replace(':', ''))) {
        currentTime = this.recordDurationTime;
      } else {
        switch(currentTime.length) {
          case 1:
            currentTime = `${currentTime}:00`;
            break
          case 3:
            currentTime = `${currentTime}0`;
            break
        }
      }
      this.recordCurrentTime = `0${currentTime}`;
    },
    onRecord(type) {
      switch (type) {
        case 'recording':
          if (this.mediaRecorder) {
            this.recordStartDate = Date.now();
            this.mediaRecorder.start();
            console.log(this.mediaRecorder.state);
            console.log("recorder started");
          }

          this.recordTimeInterval = setInterval(() => {
            let time = (Date.now() - this.recordStartDate) / 1000
            if (time > 10) {
              clearInterval(this.recordTimeInterval);
              this.recordDurationTime = '10:00';
              this.onRecord('end');
              return;
            }
            time = String(time).replace('.', ':').substr(0, 4);
            if (time.length === 3) {
              time = `${time}0`;
            }
            this.recordDurationTime = `0${time}`;
          }, 30);
          break
        case 'end':
          if (this.mediaRecorder?.state === 'recording') {
            this.mediaRecorder.stop();
            console.log("recorder stopped");
          }

          clearInterval(this.recordTimeInterval)
          break
        case 'pause':
          this.myVoiceAudio?.pause();
          this.recordState = 'complete';
          break;        
        case 'play':
          this.playMyRecord()
          this.recordPercent = 0;
          break;
        case 'ready':
          this.recordDurationTime = '00:00'
          break
      }
      this.recordState = type
    },
    playMyRecord(){
      this.myVoiceAudio.play();
      this.recordState = 'play';
    },
    pauseMyRecord(){
      this.myVoiceAudio?.pause();
      this.recordState = 'pause';
    },
  }
}
</script>

<style lang="scss" scoped>
.device-setting-audio-test-component {}
.device-setting-audio-test {
  height: 100%;
}
.device-set-test {
  width: 400px;
  height: 100%;
  padding: 30px 44px;
  background-color: $White;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.device-set-test-header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 30px;
  right: 44px;
  left: 44px;
}
.device-set-test-title-wrapper {}
.device-set-test-title {
  font-weight: 700;
  color: #333;
}
.device-set-test-confirm-btn-wrapper {
  position: absolute;
  right: 0;
}
.device-set-test-confirm-btn {
  font-size: 14px;
  color: #333;
  opacity: 0.8;
  transition: 0.1s ease-out;
  &:hover {
    opacity: 1;
  }
}
.device-set-test-body {
  margin-bottom: 90px;
}
.device-set-test-record {}
.device-set-test-record-header {}
.device-set-test-record-complete-container {
  margin-bottom: 8px;
}
.device-set-test-record-complete-mark {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  border: 1px solid #59f;
  border-radius: 100%;
  background: url('~@/assets/images/check_blue.svg') no-repeat center / 30px auto;
}
.device-set-test-record-complete-text-wrapper {
  margin-top: 32px;
}
.device-set-test-record-text-container {}
.device-set-test-record-text {
  &.complete {
    font-size: 20px;
    font-weight: 700;
    color: #333;
    line-height: 27px;
  }
  &.title {
    color: #4b4b4b;
    line-height: 22px;
  }
  &.description {
    margin-top: 8px;
    font-size: 14px;
    line-height: 19px;
    color: #898989;
  }
  &.time {
    font-size: 52px;
    color: #000;
  }
}
.device-set-test-record-body {
  margin-top: 40px;
}
.device-set-test-record-bar-container {
  margin-top: 64px;
}
.device-set-test-record-bar-wrapper {}
.device-set-test-record-bar {
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background-color: #f1f1f1;
  -webkit-appearance: none;

  &::-webkit-slider-thumb {
    width: 12px;
    height: 12px;
    border-radius: 100%;
    background: #59f;
    -webkit-appearance: none;
  }
}
.device-set-test-record-info-container {
  margin-top: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.device-set-test-record-info-time {
  font-size: 12px;
  color: #898989;
  line-height: 16px;
}
.device-set-test-record-footer {
  position: absolute;
  bottom: 186px;
  right: 44px;
  left: 44px;
}
.device-set-test-record-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 12px;
}
.device-set-test-record-btn {
  width: 150px;
  height: 52px;
  border-radius: 32px;
  font-size: 14px;
  font-weight: 700;
  transition: 0.2s ease-out;
  &.record,
  &.play {
    background-color: #59f;
    color: #fff;
  }
  &.end {
    border: 1px solid #59f;
    background-color: #fff;
    color: #267dff;
    &:hover {
      background-color: #f0f6ff;
    }
  }
  &.play {
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
      content: '';
      width: 10px;
      height: 10px;
      margin-right: 8px;
      background: url('~@/assets/images/play_white.svg') no-repeat center / 10px auto;
      display: block;
    }
  }
  &.pause {
    border: 1px solid #59f;
    background-color: #fff;
    color: #267dff;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      background-color: #f0f6ff;
    }
    &::before {
      content: '';
      width: 10px;
      height: 10px;
      margin-right: 8px;
      border-radius: 1px;
      background-color: #59f;
    }
  }
  &:hover {
    background-color: #247bff;
  }
  &.re-record {
    background-color: rgba(85, 153, 255, 0.1);
    color: #267dff;
    &:hover {
      background-color: #BDD7FF;
      color: #247BFF;
    }
  }
}
/****************** Mobile ******************/
[grm-device-mobile]{
  .device-set-test {
    width: 100%;
    height: 100%;
  }
  .device-set-test-header {
    top: 20px;
    right: 24px;
    left: 24px;
  }
  .device-set-test-record-footer {
    bottom: 24px;
  }
  .device-set-test {
    width: 100%;
    height: 100%;
  }
  .device-set-test-header {
    top: 20px;
    right: 24px;
    left: 24px;
  }
  .device-set-test-record-footer {
    bottom: 24px;
  }
}
</style>